import AboutUsModule from 'components/about-us/AboutUsModule';
import AboutUsSiteContainer from 'components/about-us/AboutUsSiteContainer';

import ChangeEmailPopup from 'components/confirmation2026/ChangeEmailPopup';
import ImageWithFallback from 'components/ImageWithFallback';
import { useState } from 'react';
import { ASSET_PREFIX } from 'utils/constants';
import styles from './EmailConfirmationBanner.module.css';

interface IEmailConfirmationBanner {
  emailAddress: string;
}

export const EmailConfirmationBanner = ({
  emailAddress,
}: IEmailConfirmationBanner) => {
  const [showChangeEmailPopup, setShowChangeEmailPopup] = useState(false);

  return (
    <AboutUsModule background={'tealGradient'} withNoPadding>
      <AboutUsSiteContainer>
        {showChangeEmailPopup && (
          <ChangeEmailPopup
            currentEmailAddress={emailAddress}
            onClose={() => setShowChangeEmailPopup(false)}
          />
        )}
        <div className={styles.banner}>
          <div className={styles.imageContainer}>
            <div className={styles.imageWrapper}>
              <ImageWithFallback
                src={`${ASSET_PREFIX}/images/account/email-preferences.svg`}
                alt="Email Preferences"
                layout="fill"
              />
            </div>
          </div>
          <div className={styles.textContainer}>
            <p className={`aboutUsTypographyBodySmall noMargin`}>
              We'll send confirmation to{' '}
              <strong className={'textItalic'}>{emailAddress}</strong>{' '}
            </p>
            <p className={`aboutUsTypographyBodySmall noMargin`}>
              <strong className="textItalic">
                Not correct?{' '}
                <span
                  className={styles.changeLink}
                  onClick={() => setShowChangeEmailPopup(true)}
                >
                  Change email
                </span>
              </strong>
            </p>
          </div>
        </div>
      </AboutUsSiteContainer>
    </AboutUsModule>
  );
};
